import React from "react"

import { PortfolioPageObj } from "scrivito/Objs/PortfolioPage/PortfolioPageObjClass"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductCategoryObj } from "scrivito/Objs/ProductCategory/ProductCategoryObjClass"
import { SelectOption } from "shared/types/Select"

import { ProductFilterFormData } from "entities/products/types/ProductFilter"
import { ProductCategoryDetails } from "widgets/product-category-details/ProductCategoryDetails"
import { ProductCategoryOverview } from "widgets/product-category-overview/ProductCategoryOverview"

export interface PortfolioProductSelectViewModel {
  portfolio: PortfolioPageObj | undefined

  productCategories: ProductCategoryObj[] | undefined
  selectedProductCategory: ProductCategoryObj | null

  productGroupOptions: SelectOption<string>[] | undefined

  products: ProductObj[] | undefined

  onProductSelect: (productObj: ProductObj) => void

  filter?: ProductFilterFormData
  onProductFilterChange: (formData: ProductFilterFormData) => void

  onBack: () => void
  onCategorySelect: (obj: ProductCategoryObj) => void
}

export const PortfolioProductSelectView = React.memo(
  ({
    products,
    portfolio,
    productCategories,
    selectedProductCategory,
    productGroupOptions,
    filter,
    onBack,
    onProductFilterChange,
    onProductSelect,
    onCategorySelect
  }: PortfolioProductSelectViewModel) => {
    if (!portfolio) {
      return null
    }

    return (
      <div className="portfolio-product-select">
        {selectedProductCategory ? (
          <ProductCategoryDetails
            category={selectedProductCategory}
            products={products}
            productGroupOptions={productGroupOptions}
            mode="button"
            onBack={onBack}
            onProductSelect={onProductSelect}
            filter={filter}
            onFilterChange={onProductFilterChange}
          />
        ) : (
          <ProductCategoryOverview
            mode="button"
            page={portfolio}
            filter={filter}
            productCategories={productCategories}
            onCategorySelect={onCategorySelect}
            products={products}
            onFilterChange={onProductFilterChange}
            onProductSelect={onProductSelect}
          />
        )}
      </div>
    )
  }
)
